import {
    USER_PF_SCHEDULE_FETCHING,
    USER_PF_SCHEDULE_FAILED,
    USER_PF_SCHEDULE_SUCCESS
} from "../actions/types";

const initialState = {
    result: null,
    isFetching: false,
    isError: false,
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case USER_PF_SCHEDULE_FETCHING:
        return { ...state, result: null, isFetching: true, isError: false };
      case USER_PF_SCHEDULE_FAILED:
        return { ...state, result: null, isFetching: false, isError: true };
      case USER_PF_SCHEDULE_SUCCESS:
        return { ...state, result: payload, isFetching: false, isError: false };
      default:
        return state;
    }
}
